import MenuMainComponent from './menu-main.component'

const MenuMainModule = angular.module('cdbl.menu-main', [

])
  .component('cdblMenuMain', MenuMainComponent)
  .name

export default MenuMainModule
